const EyesIcon = () =>
{
      return (
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8.00008 4.33333C10.5267 4.33333 12.7801 5.75333 13.8801 8C12.7801 10.2467 10.5334 11.6667 8.00008 11.6667C5.46675 11.6667 3.22008 10.2467 2.12008 8C3.22008 5.75333 5.47341 4.33333 8.00008 4.33333ZM8.00008 3C4.66675 3 1.82008 5.07333 0.666748 8C1.82008 10.9267 4.66675 13 8.00008 13C11.3334 13 14.1801 10.9267 15.3334 8C14.1801 5.07333 11.3334 3 8.00008 3ZM8.00008 6.33333C8.92008 6.33333 9.66675 7.08 9.66675 8C9.66675 8.92 8.92008 9.66667 8.00008 9.66667C7.08008 9.66667 6.33342 8.92 6.33342 8C6.33342 7.08 7.08008 6.33333 8.00008 6.33333ZM8.00008 5C6.34675 5 5.00008 6.34667 5.00008 8C5.00008 9.65333 6.34675 11 8.00008 11C9.65341 11 11.0001 9.65333 11.0001 8C11.0001 6.34667 9.65341 5 8.00008 5Z" fill="white" />
            </svg>

      )
}

export default EyesIcon